/*! *********************************************************************
 *
 * Copyright 2021 Adobe
 * All Rights Reserved.
 *
 * NOTICE: All information contained herein is, and remains
 * the property of Adobe and its suppliers, if any. The intellectual
 * and technical concepts contained herein are proprietary to Adobe
 * and its suppliers and are protected by all applicable intellectual
 * property laws, including trade secret and copyright laws.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Adobe.
 *************************************************************************
 */
import _map from 'lodash/map';
import { Asset } from './Asset';
import { PhysicalSizesInterface, sizeUnit } from './RawAsset';

enum ModelFormats {
  FBX = 'fbx',
  GLB = 'glb'
}

const ModelDefaultFormat = ModelFormats.FBX;

class Model extends Asset {
  isModel: boolean;

  constructor(rawAsset: Object) {
    super(rawAsset);
    this.isModel = true;
    this.formats = [ModelFormats.FBX, ModelFormats.GLB];
    this.defaultFormat = ModelDefaultFormat;
  }

  get model() {
    return this.findAttachment({
      __typename: 'PreviewAttachment',
      tag: 'model',
      kind: 'model'
    });
  }

  /**
   * Get physical size
   * @returns {Array<PhysicalSizesInterface> | null} values in meters
   */
  get physicalSizes(): Array<PhysicalSizesInterface> | null {
    const physicalSize = this.getExtraData('physicalSize');
    if (!physicalSize) return null;

    const sizes = _map(physicalSize.split('/'), _size => {
      const size = Number(_size);
      return { raw: size, computed: this._computeSize(size * 100) };
    });
    return sizes;
  }
}

export { Model, ModelFormats, ModelDefaultFormat };
